import * as React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Container, useMediaQuery } from '@mui/material';
import { getBreakPoints } from '../../components/other/ConfigBasic';
import { useEffect } from 'react';
import { useState } from 'react';
import SimpleSnackbar from '../../components/ui/SimpleSnackbar';
import { useGetLogbookSetting } from '../../api/LogbookApi';
import { ReceiptFormMobile, ReceiptFormDesktop } from '../../components/Cost/ReceiptForm';

export default function Costs() {
    const { id } = useParams();
    const desktop900 = useMediaQuery(getBreakPoints().desktop900);
    const navigate = useNavigate();
    const location = useLocation();
    const [message, setMessage] = useState('');
    const logbookSetting = useGetLogbookSetting(setMessage);
    const [costCentreList, setCostCentreList] = useState([]);
    const [costObjectList, setCostObjectList] = useState([]);

    useEffect(() => {
        if (logbookSetting !== undefined) {
            const allCostCentre = logbookSetting?.map?.has('costCentre') ? logbookSetting?.map.get('costCentre') : [];
            const allCostObject = logbookSetting?.map?.has('costObject') ? logbookSetting?.map.get('costObject') : [];
            setCostCentreList(allCostCentre.filter((costCentre) => costCentre.active === true));
            setCostObjectList(allCostObject.filter((costObject) => costObject.active === true));
        }
    }, [logbookSetting]);

    useEffect(() => {
        if (location.state !== null && location.state.snackbarMessage !== null) {
            setMessage(location.state.snackbarMessage);
            navigate(location.pathname);
        }
    }, [navigate, location]);

    return (
        <>
            <Container maxWidth='md' sx={{ m: 0, p: 0, mx: `${desktop900 ? 'auto' : '0'}` }}>
                {desktop900 ? (
                    <ReceiptFormDesktop id={id} costCentreList={costCentreList} costObjectList={costObjectList} />
                ) : (
                    <ReceiptFormMobile id={id} costCentreList={costCentreList} costObjectList={costObjectList} />
                )}
            </Container>
            {message && <SimpleSnackbar message={message} setMessage={setMessage} />}
        </>
    );
}
